import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedFacade, ProjectsFacade, customEncode, customDecode } from '@piqet-angular/data';
import { ColDef } from 'ag-grid-community';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { ProjectScenarioDataGridService } from '../project-scenario-list/project-scenario-list-data-grid.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'piqet-angular-project-scenario-manufacturing',
  templateUrl: './project-scenario-manufacturing.component.html',
  styleUrls: ['./project-scenario-manufacturing.component.scss'],
})
export class ProjectScenarioManufacturingComponent {
  headerData = {
    materialName: 'Summary of manufacturing process',
  };
  activatedRoute: any;
  columnDefs!: ColDef[];
  gridName: string = 'Project Scenario Menufacturing List';
  activatedRouteProjectId: any;

  constructor(
    private projectScenarioDataGridService: ProjectScenarioDataGridService,
    public sharedFacade: SharedFacade,
    public projectFacade: ProjectsFacade,
    public route: ActivatedRoute,
    private router: Router,
    private spinnerService: NgxSpinnerService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    this.columnDefs = this.projectScenarioDataGridService.projectScenarioDataColumn(
      this.activatedRoute
    );
  }

  ngOnInit() {}

  addManufacturingModal() {
    this.projectFacade.openNewAddProjectManufacturing(
      0,
      'Add product manufacturing process to make 1kg/litre of product',
      this.activatedRoute,
      ''
    );
  }

  change() {
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.router.navigate([
      `projects/projects-setting/${customEncode(btoa(encodedValue))}/fill-data-list`,
    ]);
  }
}
